<template>
	<div class="flex flex-col">
		<div class="bg-black text-white px-8 py-16 lg:p-16 relative">
			<div class="container mx-auto">
				<h2 class="hidden md:block font-header uppercase text-lg text-center text-sand mb-6">Filter events</h2>
				<div class="flex flex-col md:grid md:grid-cols-4 justify-between gap-8 md:gap-6 md:border-t-2 md:border-red-dark md:pt-8">
					<div class="flex gap-6 md:col-span-2 lg:col-span-3">
						<FilterGroup
							v-for="{ key, label } in TAXONOMIES"
							:key="key"
							v-model="filters[key]"
							:options="facets[key]" 
							:label="label"
						/>
						<Transition name="fade">
							<button v-show="store.showReset" @click="store.clearFilters" class="absolute right-8 bottom-6 lg:relative lg:right-auto lg:bottom-auto inline-flex items-center gap-1 cursor-pointer underline decoration-1 text-white shrink-0">
								<XCircleIcon class="size-6" />
								<span>Clear filters</span>
							</button>
						</Transition>
					</div>
					<div class="flex gap-4 items-center w-full md:col-span-2 lg:col-span-1">
						<div class="w-full">
							<Autocomplete :items="items" :is-loading="isLoading" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	
</template>

<script setup>
import { storeToRefs } from "pinia";
import { XCircleIcon } from '@heroicons/vue/20/solid';
import { TAXONOMIES } from "@facet/utils/constants";
import FilterGroup from "@facet/components/filters/FilterGroup.vue";
import Autocomplete from "./Autocomplete.vue";
import { useFeedStore } from "@facet/utils/store.js";

const store = useFeedStore();
const { facets, filters, items, isLoading } = storeToRefs(store);

</script>

<style>
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease-in-out;
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(-100%);
}
</style>